var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"title"}},[_c('div',{staticClass:"no-select"},[_vm._v(_vm._s(_vm.text))]),_c('div',{staticClass:"line disable-on-xs"})])}
var staticRenderFns = []

export { render, staticRenderFns }